export function getIdRadio() {
  // https://meuplay.fabriccaradio.com.br/wishrestaurante/07687928000135 -> wishrestaurante
  return window.location.pathname.split("/")?.[1] ?? "";
}
